import { bind, TimeoutHelper, raceTimeout } from '@asamco/utils';
import { MonoTypeOperatorFunction, Observable, Subject, combineLatest } from 'rxjs';
import { filter, switchMap, tap, first, map } from 'rxjs/operators';
import { CspSignalrBase } from './csp-signalr-base';

export abstract class AckReadySignalrBase extends CspSignalrBase {
	protected payloadReadySubject: Subject<any> = new Subject<any>();
	protected acknowledgeRequestSubject: Subject<any> = new Subject<any>();
	protected connectionResultSubject: Subject<any> = new Subject<any>();

	// make sure to add to, not overwrite these...
	protected events = [
		{ methodName: 'PayloadReady', newMethod: this.payloadReady },
		{ methodName: 'AcknowledgeRequest', newMethod: this.acknowledgeRequest },
		{ methodName: 'ConnectionResult', newMethod: this.connectionResult },
	];

	@bind
	payloadReady(payloadReadyResult) {
		this.payloadReadySubject.next(payloadReadyResult);
	}

	@bind
	acknowledgeRequest(acknowledgeResult) {
		this.acknowledgeRequestSubject.next(acknowledgeResult);
	}

	@bind
	connectionResult(connectionResult) {
		this.connectionResultSubject.next(connectionResult);
	}

	public payloadReadyObservable(): Observable<any> {
		return this.payloadReadySubject.asObservable();
	}

	public acknowledgeRequestObservable(): Observable<any> {
		return this.acknowledgeRequestSubject.asObservable();
	}

	public connectionResultObservable(): Observable<any> {
		return this.connectionResultSubject.asObservable();
	}

	addFunctionAck(timeout = TimeoutHelper.AckTimeout): MonoTypeOperatorFunction<any> {
		return obs$ => combineLatest([this.acknowledgeRequestObservable(), obs$]).pipe(
			filter(([prr, rm]) => rm.requestId === prr.requestId),
			raceTimeout(timeout, TimeoutHelper.AckFailMessage),
			map(([prr, rm]) => prr)
		);
	}

	addAckAndPayload(): MonoTypeOperatorFunction<any> {
		return obs$ => {
			const acked = obs$.pipe(
				this.addFunctionAck()
			);
			return combineLatest([this.payloadReadyObservable(), acked]).pipe(
				filter(([prr, rm]) => rm.requestId === prr.requestId),
				map(([r, rm]) => {
					if (r.status === 'Critical') {
						let message = r.message || '';
						if (!message.endsWith('.')) message += '.';
						throw new Error(`${message}`);
					} else if (r.status === 'ErrorMessage') {
						throw new Error(r.message);
					}
					return r;
				}),
				first(r => r.status === 'Success')
			);
		};
	}
}
